import React from 'react';

import { useGetPlanCIPConfigQuery } from '../queries';

import { CIPStatistic } from './components';
import { useCIPStatisticLogic, useGetCIPReportURL } from './hooks';
import { useGetCIPStatisticQuery } from './queries';

const CIPStatisticContainer: React.FC = () => {
  const { isLoading: isConfigLoading, data: configData } = useGetPlanCIPConfigQuery();
  const { isLoading, isEmpty, data } = useGetCIPStatisticQuery();
  const { tiles, isDetailsLinkVisible, isHidden } = useCIPStatisticLogic({
    data,
    isDataEmpty: isEmpty,
    isConfigShowed: configData.isShowed,
    isConfigLoading,
  });

  const currentURL = useGetCIPReportURL();
  if (isHidden) {
    return null;
  }

  return (
    <CIPStatistic
      url={currentURL}
      isLoading={isLoading}
      tiles={tiles}
      closureDelayDays={configData.CIPAccountDelayDays}
      isDetailsLinkVisible={isDetailsLinkVisible}
    />
  );
};

export default CIPStatisticContainer;
